var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('v-main',[_c('router-view')],1),_c('rodape'),_c('PopupWhats')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }